import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', href: '/' },
  { label: '娱乐八卦', href: '/category/yule-bagua' },
  { label: '网红黑料', href: '/category/wanghong-heiliao' },
  { label: '社会热点', href: '/category/shehui-redian' },
  { label: '综艺剧透', href: '/category/zongyi-jumu' },
  { label: '关于我们', href: '/about' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (href: string) => {
    if (href === '/') return location.pathname === '/';
    return location.pathname.startsWith(href);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md border-b border-background-200'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${isScrolled ? 'bg-primary-500' : 'bg-primary-500/90'}`}>
              <i className="ri-fire-line text-white text-lg"></i>
            </div>
            <span className={`font-heading text-xl font-bold whitespace-nowrap ${isScrolled ? 'text-foreground-900' : 'text-white'}`}>
              黑料社区网
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  isActive(link.href)
                    ? isScrolled
                      ? 'text-primary-500 bg-primary-50'
                      : 'text-white bg-white/20'
                    : isScrolled
                      ? 'text-foreground-600 hover:text-primary-500 hover:bg-background-100'
                      : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <button className={`w-9 h-9 rounded-full flex items-center justify-center transition-colors duration-200 cursor-pointer whitespace-nowrap ${
              isScrolled ? 'text-foreground-500 hover:text-primary-500 hover:bg-background-100' : 'text-white/80 hover:text-white hover:bg-white/10'
            }`}>
              <i className="ri-search-line text-lg"></i>
            </button>
            <button className={`w-9 h-9 rounded-full flex items-center justify-center transition-colors duration-200 cursor-pointer whitespace-nowrap ${
              isScrolled ? 'text-foreground-500 hover:text-primary-500 hover:bg-background-100' : 'text-white/80 hover:text-white hover:bg-white/10'
            }`}>
              <i className="ri-notification-3-line text-lg"></i>
            </button>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-9 h-9 rounded-lg flex items-center justify-center cursor-pointer whitespace-nowrap ${
              isScrolled ? 'text-foreground-700' : 'text-white'
            }`}
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-background-200 shadow-lg">
          <nav className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  isActive(link.href)
                    ? 'text-primary-500 bg-primary-50'
                    : 'text-foreground-600 hover:text-primary-500 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}